import { defineMessages } from 'react-intl';

export default defineMessages({
    setPaperLessTitle:{
        id: 'policy.common.directives.paperless.setPaperLessTitle',
        defaultMessage: 'Go Paperless - Now Offering Electronic Document Delivery'
    },
    optOut:{
        id: 'policy.common.directives.paperless.optOut',
        defaultMessage: 'Keep Paper Delivery'
    },
    agree:{
        id: 'policy.common.directives.paperless.agree',
        defaultMessage: 'Go Paperless – Switch to Electronic Delivery'
    },
    consentTitle:{
        id: 'policy.common.directives.paperless.consentTitle',
        defaultMessage: 'I consent to Electronic Delivery:'
    },
    consentDescription:{
        id: 'policy.common.directives.paperless.consentDescription',
        defaultMessage: 'You have been registered for Digital Delivery via Optim for one or more of your policies, please provide your consent to continue with electronic delivery of your policy documents.'
    }
});
